import { createFeatureSelector } from "@ngrx/store";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";

/**
 * Selector for list time slot (TYPE: 1)
 */
export const listTimeSlot = createFeatureSelector<GenericStoreApiData>(
  AppSettings.KEY_TIMESLOT
);

/**
 * Selector for list time slot (TYPE: 24)
 */
export const listGroupTimeSlot = createFeatureSelector<GenericStoreApiData>(
  AppSettings.KEY_GROUP_TIMESLOT
);
